import { range, titleCase } from '@imcc/utilities';
import { FilterValue } from '@features/search/search-filters/filter-value/filter-value';
import { Filter } from '../search/search-filters/filter/filter';

function filterValue(key: string, title = titleCase(key)): FilterValue {
  return { key, title, isActive: false };
}

export function getInitialFilters(): Filter[] {
  const currentYear = new Date().getFullYear();
  const fiscalYearBuckets = range(2021, currentYear + 1).map((year) => filterValue(`FY${year % 100}`, `FY${year % 100}`));

  return [
    {
      title: 'Fiscal Year',
      key: 'fiscalYear',
      values: fiscalYearBuckets,
    },
    {
      title: 'Launch',
      key: 'launch',
      values: [
        filterValue('L1', 'L1 (July-September)'),
        filterValue('L2', 'L2 (October-January)'),
        filterValue('L3', 'L3 (January-March)'),
        filterValue('L4', 'L4 (April-June)'),
      ],
    },
    {
      title: 'Marketing Objective',
      key: 'marketingObjective',
      values: [
        filterValue('Attract'),
        filterValue('Activate'),
        filterValue('Convert'),
        filterValue('None', 'No MO'),
      ],
    },
    {
      title: 'Delivery',
      key: 'deliveryTypes',
      values: [filterValue('Pre-delivery', 'Pre-delivery'), filterValue('Delivery', 'Delivery')],
    },
  ];
}
